import { exists } from '../runtime.js';
import './ApiActivityType.js';
import './ApiAdditionalInfoType.js';
import './ApiAirportType.js';
import { ApiAllowedBaggageFromJSON, ApiAllowedBaggageToJSON } from './ApiAllowedBaggage.js';
import './ApiBaggageType.js';
import './ApiBaggageUnitType.js';
import './ApiBaseDataSource.js';
import './ApiBookingAction.js';
import './ApiBookingState.js';
import './ApiCabinClass.js';
import './ApiCamperFeatureType.js';
import { ApiCarrierFromJSON, ApiCarrierToJSON } from './ApiCarrier.js';
import './ApiClientType.js';
import './ApiComponentPriceType.js';
import './ApiComponentType.js';
import './ApiConfigurationDataType.js';
import './ApiDebitType.js';
import { ApiDirectionFromJSON, ApiDirectionToJSON } from './ApiDirection.js';
import './ApiDistanceUnit.js';
import './ApiDocumentSubType.js';
import './ApiDocumentType.js';
import './ApiDurationType.js';
import './ApiFilterCategory.js';
import './ApiFilterType.js';
import { ApiFlightLegFromJSONTyped } from './ApiFlightLeg.js';
import { ApiFlightSegmentFromJSONTyped } from './ApiFlightSegment.js';
import './ApiFuelType.js';
import './ApiGender.js';
import './ApiImageType.js';
import './ApiInventory.js';
import './ApiItemType.js';
import './ApiNoteOriginType.js';
import './ApiNoteType.js';
import './ApiPackagePriceComponentType.js';
import './ApiPaymentDataType.js';
import './ApiPaymentOption.js';
import './ApiPaymentState.js';
import './ApiPriceModifierType.js';
import './ApiPriceType.js';
import './ApiRecommendationServiceType.js';
import './ApiRelatedServiceRelationType.js';
import './ApiRole.js';
import { ApiRouteFromJSONTyped, ApiRouteToJSON } from './ApiRoute.js';
import './ApiRowCharacteristics.js';
import './ApiSeatCharacteristics.js';
import './ApiServiceSelectionType.js';
import './ApiSortDirection.js';
import './ApiSortOption.js';
import { ApiSpecialRequestFromJSON, ApiSpecialRequestToJSON } from './ApiSpecialRequest.js';
import './ApiSpecialRequestGroup.js';
import './ApiStaticContentType.js';
import './ApiTaxDisplay.js';
import './ApiTransmissionType.js';
import './ApiTravelStatusEnum.js';
import './ApiTravelerType.js';
import './ApiVoucherDeliveryType.js';
import './ApiWalletType.js';

/* tslint:disable */
function ApiFlightRouteFromJSON(json) {
    return ApiFlightRouteFromJSONTyped(json, false);
}
function ApiFlightRouteFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'FlightSegment') {
            return ApiFlightSegmentFromJSONTyped(json, true);
        }
        if (json['type'] === 'FlightLeg') {
            return ApiFlightLegFromJSONTyped(json);
        }
    }
    return {
        ...ApiRouteFromJSONTyped(json, ignoreDiscriminator),
        'flightCode': json['flightCode'],
        'flightNumber': json['flightNumber'],
        'equipmentType': !exists(json, 'equipmentType') ? undefined : json['equipmentType'],
        'marketingCarrier': ApiCarrierFromJSON(json['marketingCarrier']),
        'operatingCarrier': ApiCarrierFromJSON(json['operatingCarrier']),
        'departure': (json['departure']),
        'arrival': (json['arrival']),
        'direction': ApiDirectionFromJSON(json['direction']),
        'flightDuration': json['flightDuration'],
        'dateDeviation': json['dateDeviation'],
        'specialRequests': !exists(json, 'specialRequests') ? undefined : (json['specialRequests'].map(ApiSpecialRequestFromJSON)),
        'baggage': !exists(json, 'baggage') ? undefined : (json['baggage'].map(ApiAllowedBaggageFromJSON)),
    };
}
function ApiFlightRouteToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ApiRouteToJSON(value),
        'flightCode': value.flightCode,
        'flightNumber': value.flightNumber,
        'equipmentType': value.equipmentType,
        'marketingCarrier': ApiCarrierToJSON(value.marketingCarrier),
        'operatingCarrier': ApiCarrierToJSON(value.operatingCarrier),
        'departure': (value.departure),
        'arrival': (value.arrival),
        'direction': ApiDirectionToJSON(value.direction),
        'flightDuration': value.flightDuration,
        'dateDeviation': value.dateDeviation,
        'specialRequests': value.specialRequests === undefined ? undefined : (value.specialRequests.map(ApiSpecialRequestToJSON)),
        'baggage': value.baggage === undefined ? undefined : (value.baggage.map(ApiAllowedBaggageToJSON)),
    };
}

export { ApiFlightRouteFromJSON, ApiFlightRouteFromJSONTyped, ApiFlightRouteToJSON };
//# sourceMappingURL=ApiFlightRoute.js.map
